'use client';

import React, { startTransition } from 'react';

export function useHydrate<T>(value: T, initValue: T): T;
export function useHydrate<T>(value: T, initValue: T | undefined): T | undefined;
export function useHydrate<T>(value: T, initValue: T | undefined): T | undefined {
  const [val, setVal] = React.useState<T | undefined>(initValue);
  React.useEffect(() => {
    startTransition(() => {
      setVal(value);
    });
  }, [value]);
  return val;
}
